import { useShallow } from 'zustand/react/shallow';
import useProductDetailsStore from '../../../../../../stores/ProductDetails/productDetails.store';
import { UseProductDetailsCombinationColorAndTagsParams } from '../types/productDetailsCombinationColorAndTags.types';

const useProductDetailsCombinationColorAndTags = ({
  productId,
  productColorId,
}: UseProductDetailsCombinationColorAndTagsParams) => {
  const { detailsProductId, setMediaProductColorId } = useProductDetailsStore(
    useShallow((state) => ({
      detailsProductId: state.productDetailsModalState.productId,
      setMediaProductColorId: state.setMediaProductColorId,
    })),
  );

  const canSelectMediaColor = productId === detailsProductId;

  const selectMediaColor = () => setMediaProductColorId(productColorId);

  return { selectMediaColor: canSelectMediaColor ? selectMediaColor : undefined };
};

export default useProductDetailsCombinationColorAndTags;
